import React from 'react';

const TestResultSummary = ({ resultData, onReview, onBack }) => {
  const score = resultData ? Math.round(resultData.percentage_score) : 0;
  const correct = resultData ? resultData.correct_answers : 0;
  const incorrect = resultData ? resultData.incorrect_answers : 0;
  const skipped = resultData ? resultData.skipped_answers : 0;
  const total = resultData ? resultData.total_questions : 0;

  let feedback = "Good effort!";
  if (score >= 90) feedback = "Excellent! You've mastered these topics.";
  else if (score >= 70) feedback = "Great job! Keep practicing to reach perfection.";
  else if (score >= 50) feedback = "Good start! Review your mistakes to improve.";
  else feedback = "Keep trying! Practice makes perfect.";

  return (
    <div className="flex flex-col items-center justify-center h-full p-8 text-center animate-fadeIn bg-slate-50 dark:bg-card-dark">
      <div className="max-w-2xl w-full bg-white dark:bg-gray-800 rounded-3xl shadow-xl border border-slate-200 dark:border-slate-700 overflow-hidden">
        
        {/* Header Section */}
        <div className="bg-primary-blue/10 dark:bg-primary-blue/20 p-8 flex flex-col items-center">
          <div className="w-24 h-24 bg-white dark:bg-gray-700 rounded-full flex items-center justify-center shadow-sm mb-4">
            <span className="material-symbols-outlined text-6xl text-yellow-500">emoji_events</span>
          </div>
          <h2 className="text-3xl font-black text-slate-800 dark:text-white mb-2">Test Complete!</h2>
          <p className="text-slate-600 dark:text-slate-300 font-medium">{feedback}</p>
        </div>

        {/* Stats Section */}
        <div className="p-8">
          <div className="flex flex-col md:flex-row items-center justify-center gap-8 mb-8">
            {/* Score Circle */}
            <div className="relative w-40 h-40 flex items-center justify-center">
              <svg className="w-full h-full transform -rotate-90">
                <circle cx="80" cy="80" r="70" stroke="currentColor" strokeWidth="12" fill="transparent" className="text-slate-100 dark:text-gray-700" />
                <circle cx="80" cy="80" r="70" stroke="currentColor" strokeWidth="12" fill="transparent" strokeDasharray={440} strokeDashoffset={440 - (440 * score) / 100} className="text-primary-blue transition-all duration-1000 ease-out" />
              </svg>
              <div className="absolute flex flex-col items-center">
                <span className="text-4xl font-black text-slate-800 dark:text-white">{score}%</span>
                <span className="text-xs font-bold text-slate-400 uppercase tracking-wider">Score</span>
              </div>
            </div>

            {/* Details Stats */}
            <div className="flex flex-col gap-4 w-full md:w-auto">
              <div className="flex items-center justify-between p-4 bg-green-50 dark:bg-green-900/20 rounded-xl border border-green-100 dark:border-green-800 w-full md:min-w-[200px]">
                <div className="flex items-center gap-3">
                  <span className="material-symbols-outlined text-green-600">check_circle</span>
                  <span className="text-sm font-bold text-slate-700 dark:text-slate-300">Correct</span>
                </div>
                <span className="text-xl font-black text-green-600">{correct}/{total}</span>
              </div>
              
              <div className="flex items-center justify-between p-4 bg-red-50 dark:bg-red-900/20 rounded-xl border border-red-100 dark:border-red-800 w-full md:min-w-[200px]">
                <div className="flex items-center gap-3">
                  <span className="material-symbols-outlined text-red-500">cancel</span>
                  <span className="text-sm font-bold text-slate-700 dark:text-slate-300">Incorrect</span>
                </div>
                <span className="text-xl font-black text-red-500">{incorrect}</span>
              </div>

              <div className="flex items-center justify-between p-4 bg-gray-50 dark:bg-gray-700/30 rounded-xl border border-gray-200 dark:border-gray-700 w-full md:min-w-[200px]">
                <div className="flex items-center gap-3">
                  <span className="material-symbols-outlined text-gray-500">remove_circle_outline</span>
                  <span className="text-sm font-bold text-slate-700 dark:text-slate-300">Skipped</span>
                </div>
                <span className="text-xl font-black text-gray-500">{skipped}</span>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={onReview}
              className="flex-1 py-3 px-6 bg-primary-blue hover:bg-blue-600 text-white font-bold rounded-xl shadow-lg shadow-blue-200 dark:shadow-none transition-all flex items-center justify-center gap-2"
            >
              <span className="material-symbols-outlined">visibility</span>
              <span>Review Answers</span>
            </button>
            <button 
              onClick={onBack}
              className="flex-1 py-3 px-6 bg-white border-2 border-slate-200 text-slate-600 hover:bg-slate-50 hover:text-slate-900 font-bold rounded-xl transition-all flex items-center justify-center gap-2 dark:bg-transparent dark:border-slate-700 dark:text-slate-300 dark:hover:bg-slate-800"
            >
              <span className="material-symbols-outlined">dashboard</span>
              <span>Back to Dashboard</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestResultSummary;
